import { NavLink } from "react-router-dom";
import { Box, Breadcrumbs, Hidden, Icon, keyframes, styled, useTheme } from "@mui/material";
import LanguageSelector from "app/contexts/LanguageSelector";

// STYLED COMPONENTS
const BreadcrumbRoot = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  width: "100%"
});

const BreadcrumbLeft = styled(Box)({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap"
});

const BreadcrumbName = styled("h4")({
  margin: 0,
  fontSize: "16px",
  paddingBottom: "1px",
  verticalAlign: "middle",
  textTransform: "capitalize"
});

const SubName = styled("span")(({ theme }) => ({
  textTransform: "capitalize",
  color: theme.palette.text.secondary
}));

const Separator = styled("h4")(({ theme }) => ({
  margin: 0,
  marginLeft: 8,
  paddingBottom: "3px",
  color: theme.palette.text.hint
}));

const StyledIcon = styled(Icon)({
  marginLeft: 8,
  marginBottom: "4px",
  verticalAlign: "middle"
});

// Create blinking animation
const blink = keyframes`
  0%, 50%, 100% { opacity: 1; }
  25%, 75% { opacity: 0; }
`;

// Styled blinking label
const HotOfferLabel = styled("div")(({ theme }) => ({
  marginLeft: theme.spacing(2),
  padding: "4px 8px",
  backgroundColor: theme.palette.error.main,
  color: "#fff",
  borderRadius: "4px",
  fontWeight: "bold",
  animation: `${blink} 1s infinite`,
  display: "inline-block",
}));

export default function Breadcrumb({ routeSegments }) {
  const theme = useTheme();
  const hint = theme.palette.text.hint;

  return (
    <BreadcrumbRoot>
      {/* LEFT SIDE: Breadcrumbs */}
      <BreadcrumbLeft>
        {routeSegments ? (
          <Hidden xsDown>
            <BreadcrumbName>{routeSegments[routeSegments.length - 1]["name"]}</BreadcrumbName>
            <Separator>|</Separator>
          </Hidden>
        ) : null}

        <Breadcrumbs
          separator={<Icon sx={{ color: hint }}>navigate_next</Icon>}
          sx={{ display: "flex", alignItems: "center", position: "relative" }}
        >
          <NavLink to="/">
            <StyledIcon color="primary">home</StyledIcon>
          </NavLink>

          {routeSegments
            ? routeSegments.map((route, index) => {
                return index !== routeSegments.length - 1 ? (
                  <NavLink key={index} to={route.path}>
                    <SubName>{route.name}</SubName>
                  </NavLink>
                ) : (
                  <SubName key={index}>{route.name}</SubName>
                );
              })
            : null}
        </Breadcrumbs>
      </BreadcrumbLeft>
      {/* <HotOfferLabel>Hot Offer</HotOfferLabel> */}
      {/* RIGHT SIDE: Language Selector */}
      <LanguageSelector />
    </BreadcrumbRoot>
  );
}
